import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CarrierChargeTypesService, CarrierChargeType } from '../../../../../services/forwarding/carrier-charge-types.service';

@Component({
  selector: 'app-charge-types-tab',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './charge-types-tab.html',
  styleUrl: './charge-types-tab.css'
})
export class ChargeTypesTabComponent implements OnInit {
  selectedModeFilter = 'ALL';
  searchTerm = '';
  showAddModal = false;
  isEditMode = false;
  editingId: number | null = null;

  // Form data
  formData: CarrierChargeType = this.getEmptyFormData();

  // Charge types data from service
  chargeTypes: CarrierChargeType[] = [];

  filteredChargeTypes: CarrierChargeType[] = [];

  constructor(private chargeTypesService: CarrierChargeTypesService) {}

  ngOnInit(): void {
    console.log('[ChargeTypesTab] Component initialized');
    // Subscribe to charge types from service
    this.chargeTypesService.getChargeTypes().subscribe(types => {
      this.chargeTypes = types;
      this.applyFilters();
    });
  }

  filterByMode(mode: string): void {
    this.selectedModeFilter = mode;
    console.log('[ChargeTypesTab] Filter by mode:', mode);
    this.applyFilters();
  }

  applyFilters(): void {
    this.filteredChargeTypes = this.chargeTypes.filter(ct => {
      const matchesMode = this.selectedModeFilter === 'ALL' || ct.mode === this.selectedModeFilter;
      const matchesSearch = !this.searchTerm ||
        ct.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        ct.remarks.toLowerCase().includes(this.searchTerm.toLowerCase());
      return matchesMode && matchesSearch;
    });
  }

  openAddModal(): void {
    this.isEditMode = false;
    this.editingId = null;
    this.formData = this.getEmptyFormData();
    this.showAddModal = true;
  }

  editChargeType(chargeType: CarrierChargeType): void {
    this.isEditMode = true;
    this.editingId = chargeType.id || null;
    this.formData = { ...chargeType };
    this.showAddModal = true;
  }

  deleteChargeType(chargeType: CarrierChargeType): void {
    if (confirm(`Are you sure you want to delete "${chargeType.name}"?`)) {
      if (chargeType.id) {
        this.chargeTypesService.deleteChargeType(chargeType.id);
      }
      console.log('[ChargeTypesTab] Deleted charge type:', chargeType.name);
    }
  }

  saveChargeType(): void {
    if (this.isEditMode && this.editingId) {
      this.chargeTypesService.updateChargeType(this.editingId, this.formData);
    } else {
      this.chargeTypesService.addChargeType(this.formData);
    }
    this.closeModal();
    console.log('[ChargeTypesTab] Saved charge type:', this.formData.name);
  }

  closeModal(): void {
    this.showAddModal = false;
    this.formData = this.getEmptyFormData();
  }

  getAppliesToDisplay(appliesTo: string[]): string {
    return appliesTo.join(', ');
  }

  private getEmptyFormData(): CarrierChargeType {
    return {
      name: '',
      mode: 'SEA',
      appliesTo: [],
      chargeBasis: '',
      remarks: ''
    };
  }
}
